module.exports = __webpack_public_path__ + "img/chpc_home_index_hx_10.7ec11f73.png";